module.exports = __webpack_public_path__ + "img/teamImg18.79ced837.jpg";